import { ErrorMessage } from "formik";
import React, { Component } from "react";
import CurrencyInput from "components/Input/currencyInput.component";
import Subtitle from "components/Subtitle/subtitle.component";
import Input from "../../components/Input/input.component";
import {
	CEPMask,
	CNPJMask,
	empenhoMask,
	numberMask,
	phoneMask
} from "../../components/Input/Masks";
import WidgetModalForm, {
	ModalFormContext
} from "../../components/Modal/modalForm.component";
import Required from "../../components/Required/required.component";
import SelectMulti from "../../components/SelectMulti/selectmulti.component";
import crepdecService from "../../services/crepdecService";
import municipioService from "../../services/municipioService";
import { connect } from "react-redux";
import {
	DefesaCivilValidationSchema,
	RegistroValidationSchema
} from "./entrada.modal.validates";

const mapStateToProps = state => ({ usuario: state.auth.usuario });

class EntradaModal extends Component {
	constructor(props) {
		super(props);
		this.onChangeCrepdec = this.onChangeCrepdec.bind(this);
		this.state = {
			validationSchema: {},
			entrada: {
				tipoEstoque: "",
				numero: "",
				crepdecs: [],
				crepdecsForm: [],
				validade: undefined,
				qtdeEntradaSaida: "",
				valorUnitario: "",
				empresa: {
					nome: "",
					cnpj: "",
					email: "",
					telefonePrincipal: "",
					telefoneSecundario: "",
					endereco: {
						municipio: {
							codigoIbge: 0
						},
						cep: "",
						bairro: "",
						logradouro: "",
						numero: "",
						complemento: ""
					}
				},
				daca: {
					id: this.props.dacaId
				}
			},
			telefonePrincipalExibicao: "",
			telefoneSecundarioExibicao: "",
			municipioSelecionado: null,
			municipios: [],
			crepdecs: []
		};
	}

	async componentDidMount() {
		const responseMunicipio = await municipioService.findAll();
		const responseCrepdec = await crepdecService.findAll();
		this.setState({ validationSchema: RegistroValidationSchema });
		this.setState({ municipios: [...responseMunicipio.data] });
		this.setState({ crepdecs: [...responseCrepdec.data] });
	}

	onChangeCrepdec(lista, values) {
		const listaMap = lista ? lista.map(c => c.object) : null;

		this.setState({
			entrada: {
				...values,
				crepdecs: listaMap,
				crepdecsForm: lista
			}
		});
	}

	onChangeMunicipio(item) {
		const newState = this.state;
		newState.municipioSelecionado = item;
		newState.entrada.empresa.endereco.municipio.codigoIbge = item.value;
		this.setState(newState);
	}

	onChangeValorUnitario = value => {
		if (value.target.value) {
			return parseFloat(value.target.value.toString().replace(/,/, "."));
		}
		return "";
	};

	onChangeValidationSchema = tipoEstoque => {
		if (tipoEstoque !== "DEFESA_CIVIL") {
			this.setState({ validationSchema: RegistroValidationSchema });
		} else {
			this.setState({ validationSchema: DefesaCivilValidationSchema });
		}
	};

	render() {
		const {
			props: {
				isOpenRegistrar,
				handleCloseRegistrar,
				handleSubmitEntrada,
				nomeDaca
			},
			state: {
				entrada,
				crepdecs,
				municipioSelecionado,
				municipios,
				validationSchema
			}
		} = this;
		return (
			<WidgetModalForm
				textCancelar="Cancelar"
				textConfirmar="Cadastrar"
				validationSchema={validationSchema}
				title="Registrar entrada"
				confirmar={(values, props) => {
					const dados = values;
					if (
						dados.numero &&
						dados.numero.length > 9 &&
						dados.tipoEstoque !== "COMPRA_EMERGENCIAL"
					) {
						dados.numero = dados.numero.substring(0, 9);
					}
					if (dados.tipoEstoque === "COMPRA_EMERGENCIAL") {
						dados.numero = dados.numero.replace(/[^\d]/g, "");
						dados.crepdecs = [];
						dados.validade = undefined;
					}
					const dadosFinais = {};
					Object.assign(dadosFinais, dados);
					handleSubmitEntrada(dadosFinais, props);
				}}
				isOpen={isOpenRegistrar}
				cancelar={handleCloseRegistrar}
				initialValues={entrada}
				modalConfirmarFechar
				modalConfirmarCancelar
				modalConfirmarCancelarTitulo="Atenção!"
				modalConfirmarCancelarCorpo="Tem certeza que deseja cancelar? Todos os dados preenchidos serão perdidos."
				iconCancelar="fas fa-times"
				iconConfirmar="fas fa-save"
				tamanho="lg"
			>
				<ModalFormContext.Consumer>
					{({ values, handleChange, setFieldValue }) => (
						<div>
							<div className="row">
								<div className="col-12">
									<p>
										<strong>Item:</strong> {nomeDaca}{" "}
									</p>
								</div>
								<div className="col-md-12">
									<div>
										<label>
											Tipo de entrada: <Required />
										</label>
									</div>
									<div className="form-group">
										<div className="form-check form-check-inline">
											<Input
												id="radio_1"
												name="tipoEstoque"
												type="radio"
												className="form-check-input"
												onChange={() => {
													setFieldValue(
														"tipoEstoque",
														"ARP"
													);
													this.onChangeValidationSchema(
														"ARP"
													);

													if (
														values.numero &&
														!values.numero.match(
															/\d{4}([/])\d{4}/g
														)
													) {
														setFieldValue(
															"numero",
															`${values.numero.substring(
																0,
																4
															)}/${values.numero.substring(
																4,
																values.numero
																	.length
															)}`
														);
													}
												}}
											/>
											<label
												htmlFor="radio_1"
												className="form-check-label pointer-text"
											>
												ARP
											</label>
										</div>

										<div className="form-check form-check-inline">
											<Input
												id="radio_2"
												name="tipoEstoque"
												type="radio"
												className="form-check-input"
												onChange={() => {
													setFieldValue(
														"tipoEstoque",
														"COMPRA_EMERGENCIAL"
													);
													this.onChangeValidationSchema(
														"COMPRA_EMERGENCIAL"
													);
												}}
											/>
											<label
												htmlFor="radio_2"
												className="form-check-label pointer-text"
											>
												Compra emergencial
											</label>
										</div>

										<div className="form-check form-check-inline">
											<Input
												id="radio_3"
												name="tipoEstoque"
												type="radio"
												className="form-check-input"
												onChange={() => {
													setFieldValue(
														"tipoEstoque",
														"DEFESA_CIVIL"
													);
													this.onChangeValidationSchema(
														"DEFESA_CIVIL"
													);
												}}
											/>
											<label
												htmlFor="radio_3"
												className="form-check-label pointer-text"
											>
												Defesa Civil Nacional
											</label>
										</div>
									</div>
								</div>
								<ErrorMessage
									name="tipoEstoque"
									render={msg => (
										<span className="ml-3 text-danger">
											{msg}
										</span>
									)}
								/>
							</div>

							{/* ARP */}
							{values.tipoEstoque === "ARP" && (
								<React.Fragment>
									<div className="row">
										<div className="col-md-6">
											<label>
												Número da ARP: <Required />
											</label>
											<div className="form-group">
												<Input
													placeholder="0000/0000"
													mask={empenhoMask}
													type="input"
													name="numero"
													onChange={handleChange}
													value={values.numero}
												/>
												<ErrorMessage
													name="numero"
													render={msg => (
														<span className="text-danger">
															{msg}
														</span>
													)}
												/>
											</div>
										</div>
										<div className="col-md-6">
											<label>
												Validade: <Required />
											</label>
											<div className="form-group">
												<Input
													type="date"
													name="validade"
													max="9999-12-31"
													onChange={handleChange}
													value={values.validade}
												/>
												<ErrorMessage
													name="validade"
													render={msg => (
														<span className="text-danger">
															{msg}
														</span>
													)}
												/>
											</div>
										</div>
									</div>
									<div className="row">
										<div className="col-md-12">
											<label>
												CREPDEC(s) atendida(s):{" "}
												<Required />
											</label>
											<div className="form-group">
												<SelectMulti
													isMulti
													uniqueKey="id"
													name="crepdecsForm"
													label="nome"
													value={entrada.crepdecsForm}
													onChange={lista =>
														this.onChangeCrepdec(
															lista,
															values
														)
													}
													options={crepdecs}
												/>
												<ErrorMessage
													name="crepdecsForm"
													render={msg => (
														<span className="text-danger">
															{msg}
														</span>
													)}
												/>
											</div>
										</div>
									</div>
								</React.Fragment>
							)}

							{/* COMPRA EMERGENCIAL */}
							{values.tipoEstoque === "COMPRA_EMERGENCIAL" && (
								<div className="row">
									<div className="col-md-12">
										<label>
											Número da solicitação de empenho:{" "}
											<Required />
										</label>
										<div className="form-group">
											<Input
												type="input"
												name="numero"
												onChange={handleChange}
												value={values.numero}
												maxLength="20"
												mask={numberMask}
											/>
											<ErrorMessage
												name="numero"
												render={msg => (
													<span className="text-danger">
														{msg}
													</span>
												)}
											/>
										</div>
									</div>
								</div>
							)}

							{(values.tipoEstoque === "COMPRA_EMERGENCIAL" ||
								values.tipoEstoque === "ARP") && (
								<React.Fragment>
									<div className="row">
										<div className="col-md-6">
											<label>
												Quantidade: <Required />
											</label>
											<div className="form-group">
												<Input
													maxLength="18"
													type="text"
													mask={numberMask}
													name="qtdeEntradaSaida"
													onChange={handleChange}
													value={
														values.qtdeEntradaSaida
													}
												/>
												<ErrorMessage
													name="qtdeEntradaSaida"
													render={msg => (
														<span className="text-danger">
															{msg}
														</span>
													)}
												/>
											</div>
										</div>
										<div className="col-md-6">
											<label>
												Valor unitário: <Required />
											</label>
											<div className="form-group">
												<div className="input-group-prepend">
													<div className="input-group-text">
														R$
													</div>
													<CurrencyInput
														value={
															values.valorUnitario !==
																0 &&
															values.valorUnitario !==
																""
																? values.valorUnitario
																: null
														}
														handleChange={e => {
															setFieldValue(
																"valorUnitario",
																e.target.value
															);
														}}
														precision="2"
													/>
												</div>
												<ErrorMessage
													name="valorUnitario"
													render={msg => (
														<span className="text-danger">
															{msg}
														</span>
													)}
												/>
											</div>
										</div>
									</div>
									<div className="row">
										<div className="col-md-12">
											<div className="mb-2">
												<Subtitle>
													Dados da Empresa
												</Subtitle>
											</div>
											<label>
												Empresa: <Required />
											</label>
											<div className="form-group">
												<Input
													type="input"
													name="empresa.nome"
													onChange={handleChange}
													value={values.empresa.nome}
												/>
												<ErrorMessage
													name="empresa.nome"
													render={msg => (
														<span className="text-danger">
															{msg}
														</span>
													)}
												/>
											</div>
										</div>
									</div>

									<div className="row">
										<div className="col-md-4">
											<label>
												CNPJ: <Required />
											</label>
											<div className="form-group">
												<Input
													placeholder="00.000.000/0000-00"
													mask={CNPJMask}
													type="text"
													name="empresa.cnpj"
													onChange={handleChange}
													value={values.empresa.cnpj}
												/>
												<ErrorMessage
													name="empresa.cnpj"
													render={msg => (
														<span className="text-danger">
															{msg}
														</span>
													)}
												/>
											</div>
										</div>
										<div className="col-md-8">
											<label>
												Município: <Required />
											</label>
											<div className="form-group">
												<SelectMulti
													isClearable={false}
													isMulti={false}
													name="empresa.endereco.municipio.codigoIbge"
													uniqueKey="codigoIbge"
													label="nome"
													value={municipioSelecionado}
													onChange={item => {
														this.onChangeMunicipio(
															item
														);
													}}
													options={municipios}
												/>
												<ErrorMessage
													name="empresa.endereco.municipio.codigoIbge"
													render={msg => (
														<span className="text-danger">
															{msg}
														</span>
													)}
												/>
											</div>
										</div>
									</div>

									<div className="row">
										<div className="col-md-12">
											<label>
												E-mail: <Required />
											</label>
											<div className="form-group">
												<Input
													type="input"
													name="empresa.email"
													onChange={handleChange}
													value={values.empresa.email}
												/>
												<ErrorMessage
													name="empresa.email"
													render={msg => (
														<span className="text-danger">
															{msg}
														</span>
													)}
												/>
											</div>
										</div>
									</div>
									<div className="row">
										<div className="col-md-6">
											<label>
												Telefone: <Required />
											</label>
											<div className="form-group">
												<Input
													placeholder="(00) 0 0000-0000"
													mask={phoneMask}
													type="input"
													name="empresa.telefonePrincipal"
													onChange={value => {
														const result = value.target.value.replace(
															/\D/g,
															""
														);
														setFieldValue(
															"empresa.telefonePrincipal",
															result
														);
													}}
													value={
														values.empresa
															.telefonePrincipal
													}
												/>
												<ErrorMessage
													name="empresa.telefonePrincipal"
													render={msg => (
														<span className="text-danger">
															{msg}
														</span>
													)}
												/>
											</div>
										</div>
										<div className="col-md-6">
											<label>Telefone secundário:</label>
											<div className="form-group">
												<Input
													placeholder="(00) 0 0000-0000"
													mask={phoneMask}
													type="input"
													name="empresa.telefoneSecundario"
													onChange={value => {
														const result = value.target.value.replace(
															/\D/g,
															""
														);
														setFieldValue(
															"empresa.telefoneSecundario",
															result
														);
													}}
													value={
														values.empresa
															.telefoneSecundario
													}
												/>
												<ErrorMessage
													name="empresa.telefoneSecundario"
													render={msg => (
														<span className="text-danger">
															{msg}
														</span>
													)}
												/>
											</div>
										</div>
									</div>
									<div className="row">
										<div className="col-md-4">
											<label>
												CEP: <Required />
											</label>
											<div className="form-group">
												<Input
													placeholder="00.000-000"
													mask={CEPMask}
													type="input"
													name="empresa.endereco.cep"
													onChange={handleChange}
													value={
														values.empresa.endereco
															.cep
													}
												/>
												<ErrorMessage
													name="empresa.endereco.cep"
													render={msg => (
														<span className="text-danger">
															{msg}
														</span>
													)}
												/>
											</div>
										</div>
										<div className="col-md-8">
											<label>
												Bairro: <Required />
											</label>
											<div className="form-group">
												<Input
													type="input"
													name="empresa.endereco.bairro"
													onChange={handleChange}
													value={
														values.empresa.endereco
															.bairro
													}
												/>
												<ErrorMessage
													name="empresa.endereco.bairro"
													render={msg => (
														<span className="text-danger">
															{msg}
														</span>
													)}
												/>
											</div>
										</div>
									</div>
									<div className="row">
										<div className="col-md-12">
											<label>
												Logradouro: <Required />
											</label>
											<div className="form-group">
												<Input
													type="input"
													name="empresa.endereco.logradouro"
													onChange={handleChange}
													value={
														values.empresa.endereco
															.logradouro
													}
												/>
												<ErrorMessage
													name="empresa.endereco.logradouro"
													render={msg => (
														<span className="text-danger">
															{msg}
														</span>
													)}
												/>
											</div>
										</div>
									</div>
									<div className="row">
										<div className="col-md-6">
											<label>
												Número: <Required />
											</label>
											<div className="form-group">
												<Input
													type="input"
													name="empresa.endereco.numero"
													onChange={handleChange}
													value={
														values.empresa.endereco
															.numero
													}
												/>
												<ErrorMessage
													name="empresa.endereco.numero"
													render={msg => (
														<span className="text-danger">
															{msg}
														</span>
													)}
												/>
											</div>
										</div>
										<div className="col-md-6">
											<label>Complemento:</label>
											<div className="form-group">
												<Input
													type="input"
													name="empresa.endereco.complemento"
													onChange={handleChange}
													value={
														values.empresa.endereco
															.complemento
													}
												/>
											</div>
										</div>
									</div>
								</React.Fragment>
							)}

							{values.tipoEstoque === "DEFESA_CIVIL" && (
								<React.Fragment>
									<div className="row">
										<div className="col-md-6">
											<label>
												Quantidade: <Required />
											</label>
											<div className="form-group">
												<Input
													maxLength="18"
													type="text"
													mask={numberMask}
													name="qtdeEntradaSaida"
													onChange={handleChange}
													value={
														values.qtdeEntradaSaida
													}
												/>
												<ErrorMessage
													name="qtdeEntradaSaida"
													render={msg => (
														<span className="text-danger">
															{msg}
														</span>
													)}
												/>
											</div>
										</div>
									</div>
								</React.Fragment>
							)}
						</div>
					)}
				</ModalFormContext.Consumer>
			</WidgetModalForm>
		);
	}
}

export default connect(mapStateToProps)(EntradaModal);
